import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import RegistrationBackground from 'components/RegistrationBackground';
import FeedbackModal, { FeedbackPanel } from 'components/FeedbackModal';

export default function RegistrationConfirmationPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState(null);

    const email = searchParams.get('email') || '';
    const requestedJobId = Number(searchParams.get('jobId'));
    const jobId = Number.isSafeInteger(requestedJobId) && requestedJobId > 0
        ? requestedJobId
        : null;

    const handleConfirm = async () => {
        try {
            setLoading(true);

            const response = await axios.post(
                global.backingsEndpoint + 'employeeUserControl/activateUser',
                { code, email }
            );

            if (response.data?.successful === false) {
                setFeedback({
                    title: 'Hibás megerősítő kód',
                    message: response.data?.properties?.code?.[0]?.message || 'A megadott aktiváló kód nem megfelelő.',
                });
                return;
            }

            const feedbackSearchParams = new URLSearchParams();
            if (jobId) feedbackSearchParams.set('jobId', String(jobId));
            const feedbackSearch = feedbackSearchParams.toString();

            navigate(`/regisztracio-veglegesites${feedbackSearch ? `?${feedbackSearch}` : ''}`);
        } catch (error) {
            console.error(error);
            setFeedback({
                title: 'Az aktiválás sikertelen',
                message: 'A regisztrációt most nem sikerült megerősíteni. Kérjük, próbáld újra.',
            });
        } finally {
            setLoading(false);
        }
    };

    const actions = (
        <button
            type="button"
            onClick={handleConfirm}
            disabled={loading || code.length < 6}
            className="form-action-button form-action-primary flex-1"
        >
            {loading ? 'Megerősítés...' : 'Regisztráció megerősítése'}
        </button>
    );

    return (
        <>
            <RegistrationBackground>
                <FeedbackPanel
                    tone="info"
                    title="Erősítsd meg regisztrációdat"
                    message="Add meg az SMS-ben kapott, hatjegyű személyes regisztrációs kódodat."
                    actions={actions}
                >
                    <input
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="000000"
                        maxLength={6}
                        inputMode="numeric"
                        className="mt-5 min-w-0 max-w-full w-full rounded-xl border-2 border-neutral-200 bg-slate-50 p-4 text-center text-xl font-black tracking-[0.35em] text-neutral-900 outline-none transition focus:border-green-600 focus:ring-4 focus:ring-green-100"
                    />
                </FeedbackPanel>
            </RegistrationBackground>

            <FeedbackModal
                open={Boolean(feedback)}
                onClose={() => setFeedback(null)}
                tone="error"
                title={feedback?.title}
                message={feedback?.message}
                actionLabel="Újra megpróbálom"
            />
        </>
    );
}
